import {atom} from "recoil";

const state = atom({
    key: 'dashboardPage',
    default: {}
});

export default state
